module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("Cover:")]), _vm._v(" Portrait of John Lovell VII and John Siferwas. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Library British Library, Harley 7026, fol. 4, verso, © Bridgeman Images")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("1.")]), _vm._v(" Chateau Ivry-la-Bataille. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I, Nitot;")]), _vm._v(" https://commons.wikimedia.org/wiki/)")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("2.")]), _vm._v(" Titchmarsh Castle. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("3.")]), _vm._v(" Miniature of John Lovell VII and Maud Holland, Lovell Lectionary. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Library British Library, Harley 7026, fol. 5, verso © Bridgeman Images")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("4.")]), _vm._v(" Seals of Maud Holland her three sons. (© "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The National Archives TNA E42/278")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("5.")]), _vm._v(" Coats of arms used by the Lovell family. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("© Gill Smith")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("6–8.")]), _vm._v(" Old Wardour Castle. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("9–10.")]), _vm._v(" Minster Lovell. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("11.")]), _vm._v(" The tomb of John Lovell IX. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("© Tim Sutton")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("12.")]), _vm._v(" Francis Lovell’s letters to his ‘cousin’ Wiliam Stonor. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("© The National Archives SC 1/46/102")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("13.")]), _vm._v(" Francis Lovell’s Garter Stall Plate. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Public Domain, digitized by Google")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("14.")]), _vm._v(" Albrecht Dürer’s portrait of Henry Parker, Lord Morley. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("© The Trustees of the British Museum")]), _vm._v(")")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-866176ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Illustrations.vue
// module id = 69
// module chunks = 0